import * as React from 'react'
import { InputAttributes, NumericFormatProps, PatternFormat } from 'react-number-format'

import Input from './Input'
import { StyledContainerPhoneSSNCurrency, StyledLabel, StyledTopContainer } from './styles/InputStyles'

interface CustomProps {
	onChange: (event: { target: { name: string; value: string } }) => void
	name: string
	width: string
	label?: React.ReactNode
	id?: string
	testId?: string
	autoFocus?: boolean
	className?: string
	error?: boolean
	errorText?: string
	validText?: string
	valid?: boolean
}

type Props = NumericFormatProps<InputAttributes> & CustomProps

const NumberFormatPhoneNumber = React.forwardRef(
	(
		{ onChange, name, width, label, testId, id, autoFocus, className, ...other }: Props,
		ref: React.Ref<HTMLInputElement>
	) => {
		return (
			<StyledContainerPhoneSSNCurrency width={width} className={className}>
				<PatternFormat
					{...other}
					getInputRef={ref}
					onValueChange={(values) => {
						onChange({
							target: {
								name,
								value: values.value,
							},
						})
					}}
					valueIsNumericString
					type='tel'
					isAllowed={(values) => {
						const { value } = values
						if (value === undefined) {
							return true
						}
						return value.length <= 7
					}}
					customInput={Input}
					name={name}
					width={width}
					autoFocus={autoFocus}
					format='### ####'
				/>
				{label === undefined ? null : (
					<StyledTopContainer>
						{label && (
							<StyledLabel data-testid={`${testId}-label`} htmlFor={id}>
								{label}
							</StyledLabel>
						)}
					</StyledTopContainer>
				)}
			</StyledContainerPhoneSSNCurrency>
		)
	}
)

NumberFormatPhoneNumber.displayName = 'NumberFormatPhoneNumber'

export default NumberFormatPhoneNumber
